import { InjectionKey } from 'vue'

const rerenderKey: InjectionKey<() => void> = Symbol('rerender')

export { rerenderKey }
